<template>
  <div class="list-progress-circle">
    <ProgressCircle :progress="progress" />
  </div>
</template>

<script>
  import ProgressCircle from '@/components/ui/ProgressCircle';

  export default {
    name: 'InquiryProgress',
    components: {
      ProgressCircle,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      values: {
        type: Object,
        default: null,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
        states: {
          open: 0,
          progress: 65,
          progress_complete: 99,
          reviewing: 65,
          reviewed: 65,
          finished: 99,
          anonymizing: 65,
          anonymized: 100,
          closed: 100,
          archived: 100,
        },
      };
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      value() {
        const value = this.states[this.values?.status] || 0;
        return value > 100 ? 100 : value;
      },
      progress() {
        return this.value / 100;
      },
      complete() {
        return this.value >= 100;
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      //----------------------------------
      // Event Handlers
      //----------------------------------
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.list-progress-circle {
  width: calc(100% - 20px);
  display: flex;
  justify-content: center;
}
</style>
